/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreTimesheetResponseDto } from '../../models/core-timesheet-response-dto';

export interface TimesheetsControllerFindByUserId$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * User identifier
 */
  userId: string;
}

export function timesheetsControllerFindByUserId(http: HttpClient, rootUrl: string, params: TimesheetsControllerFindByUserId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreTimesheetResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, timesheetsControllerFindByUserId.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreTimesheetResponseDto>>;
    })
  );
}

timesheetsControllerFindByUserId.PATH = '/o2-core/timesheets/{tenant}/user/{userId}';
